import {
    POST_CUSTOMER_EVENT_APPROVAL_LOADING,
    POST_CUSTOMER_EVENT_APPROVAL_SUCCESS,
    POST_CUSTOMER_EVENT_APPROVAL_FAILURE,
    
} from '../../actions/types';

const INITIAL_STATE = {
    event: {
        post: {
            loading: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        },
    },
};

const customerEventApprovalReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case  POST_CUSTOMER_EVENT_APPROVAL_LOADING:
            return {
                ...state,
                event: {
                    ...state.event,
                    post: {
                        ...state.event.post,
                        loading: true,
                        success: {
                            ...state.event.post.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case  POST_CUSTOMER_EVENT_APPROVAL_SUCCESS:
            return {
                ...state,
                event: {
                    ...state.event,
                    post: {
                        ...state.event.post,
                        loading: false,
                        success: {
                            ...state.event.post.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case POST_CUSTOMER_EVENT_APPROVAL_FAILURE:
            return {
                ...state,
                event: {
                    ...state.event,
                    post: {
                        ...state.event.post,
                        loading: false,
                        success: {
                            ...state.event.post.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
    }
    return state;
}

export default customerEventApprovalReducers;
